import { useLogic } from './logic';

function withUnitSetting<P extends object>(
	WrappedComponent: React.ComponentType<P>
) {
	const withUnitSetting = (props: P) => {
		const { loading, selectUnitSettingMasterInfo } = useLogic();
		if (loading) {
			return null;
		}

		return (
			<WrappedComponent
				{...(props as P)}
				selectUnitSettingMasterInfo={selectUnitSettingMasterInfo}
			/>
		);
	};

	return withUnitSetting;
}

export default withUnitSetting;
